import React from 'react';
import studentGirlImg from '../../images/student-girl.png';

export default class ContactUs extends React.Component {

  render() {
    return (
      <section className="contact-us section-center">
        <div className="section-center-wrapper">
          <div className="hero-block">
            <h3 className="title">Your feedback is important in helping us to improve. </h3>
            <img src={studentGirlImg} alt="Contact Us"/>
          </div>
          <div className="contacts-info">
            {/*<h4 className="title">Your feedback is important in helping us to improve.</h4>*/}
            <div className="desc">Please send us your feedback whether to suggest new topics or to suggest any way we can improve the service.</div>
            <div className="main-info">
              <div className="email"><a href="mailto:support@prescriptionrevision.com">support@prescriptionrevision.com</a></div>
              <div className="address">Prescription Revision Ltd, Ballyhickey, Cahir, Co. Tipperary, Ireland</div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/informations/ContactUs.js